import threeSixtyLogo from "./360-tour.png";
import architectsTemp from "./architects-stemp.png";
import briger from "./briger.svg";
import britain from "./britain.svg";
import floorPlanDetail from "./floor-plan-detail.png";
import hostingEN from "./german-hosting-en.png";
import hosting from "./german-hosting.png";
import germany from "./germany.svg";
import livingSpaceCalc from "./living-space-calulation.png";
import logoImmoMates from "./logo-immomates.svg";
import mainLogoDark from "./main-logo-dark.png";
import mainLogo from "./main-logo.png";
import mastercard from "./mastercard.svg";
import paypal from "./paypal.svg";
import prePay from "./prepay.svg";
import sizedFloorPlanDetail from "./sized-floor-plan-detail.png";
import visa from "./visa.svg";

export {
  architectsTemp,
  briger,
  britain,
  floorPlanDetail,
  germany,
  hosting,
  hostingEN,
  livingSpaceCalc,
  logoImmoMates,
  mainLogo,
  mainLogoDark,
  mastercard,
  paypal,
  prePay,
  sizedFloorPlanDetail,
  threeSixtyLogo,
  visa,
};
